import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { getAllPageSections, getAllSubscribers } from "store/actions";
import Table from "./Table";

const Services = () => {
  const dispatch = useDispatch();

  const { subscribers, loading, error } = useSelector(
    (state) => state.subscribers
  );
  const { formatMessage, locale } = useIntl();

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  useEffect(() => {
    dispatch(getAllSubscribers());
    // dispatch(getAllPageSections("subscribers"))
  }, [dispatch]);

  return (
    <>
      <div className="subscribers-wrap">
        <Table data={subscribers} loading={loading} />
      </div>
    </>
  );
};

export default Services;
